document.addEventListener('DOMContentLoaded', () => {
    const productsSection = document.getElementById('products');
    let productData = {
        "productVariant": {
            "price": {
                "amount": productsSection.getAttribute('variant-price'),
                "currencyCode": productsSection.getAttribute('currency-code')
            },
            "product": {
                "title": productsSection.getAttribute('product-title'),
                "vendor": productsSection.getAttribute('product-vendor'),
                "id": productsSection.getAttribute('product-id'),
                "url": productsSection.getAttribute('product-url'),
            },
            "id": productsSection.getAttribute('variant-id'),
            "sku": productsSection.getAttribute('variant-sku'),
            "title": productsSection.getAttribute('variant-title'),
        }
    };
    if (productsSection) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    Shopify.analytics.publish("_product_viewed", productData);
                }
            });
        }, {
            threshold: 0.1
        });
        observer.observe(productsSection);
    }
});
